import React from 'react';
import Image from 'next/image';
import CreateResumeBtn from './CreateResumeBtn';
import IntroImage from '@/assets/resume-marketing/intro.png';

const ResumeIntro = () => {
  return (
    <div
      className="my-20 px-5 bg-slate-50 pt-[76px] tablet:my-25"
      data-ele-id="content"
      data-ele-group="landing_求职迷茫？谈职助你导航"
      data-observer-id="landing_求职迷茫？谈职助你导航"
    >
      <div className="text-center">
        <p className="text-3.25xl font-semibold mb-3 tablet:text-4pxl">
          求职迷茫？谈职助你导航
        </p>
        <p className="text-lg text-black/65 mb-5 mx-auto tablet:w-[590px]">
          职业生涯早已不同往昔，而你也在不断成长。从简历创建到职业规划，我们将始终伴你同行。未来的方向，你已决定好了吗？
        </p>
        <CreateResumeBtn dataEleGroup="landing_求职迷茫？谈职助你导航" />
      </div>
      <div className="relative w-full mt-12 tablet:h-[630px] tablet:mt-0">
        <div className="w-full h-[188px] relative tablet:h-[690px] tablet:max-h-[690px] tablet:-top-5">
          <Image
            src={IntroImage}
            alt=""
            fill
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ResumeIntro;
